<template>
  <modal
    class="POSModal"
    name="reAssignPOS"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @opened="opened"
  >
    <h5 class="py-4 text-center">
      {{ $t("text.reAssignPosModal.reAssignPos") }}
    </h5>
    <div class="">
      <div class="mt-4 input__group__block" style="margin: 0 auto; width: 50%">
        <label class="required">
          {{ $t("text.reAssignPosModal.selectCompany") }}
        </label>
        <div class="input__block" ref="target_input_div">
          <select v-model="company.id" class="form-control" v-if="company">
            <option :value="company.id">{{ company.name }}</option>
          </select>
        </div>
      </div>
      <div class="mt-4 input__group__block" style="margin: 0 auto; width: 50%">
        <label class="required">
          {{ $t("text.reAssignPosModal.selectBranch") }}
        </label>
        <div class="input__block" ref="target_input_div">
          <select
            class="form-control"
            name="dealerId"
            v-model="modalDataValues.branchId"
          >
            <option disabled selected value="select branch">
              {{ $t("text.reAssignPosModal.selectBranch") }}
            </option>
            <option
              :disabled="fromBranch ? true : false"
              :value="br.id"
              v-for="(br, i) in branches"
              :key="i"
            >
              {{ br.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="py-3 mt-3 text-center">
        <button
          @click="reAssignPOS"
          class="ep-btn ep-primary"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
        >
          {{ $t("text.reAssignPosModal.reAssignPos") }} <span></span>
        </button>
        <img
          v-show="showSpinner"
          src="@/assets/img/git_loader.gif"
          width="35px"
          class="ml-3 loader"
        />
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "reAssignPOS",
  props: ["modalData", "fromBranch", "company", "isLinked"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      modalDataValues: {},
      pumpName: "",
      companyId: "select company",
      branchId: "select branch",
      companies: [],
      branches: [],
      showSpinner: false,
      // company: localStorage.getItem("companyDetails")
      //   ? JSON.parse(localStorage.getItem("companyDetails"))
      //   : null,
    };
  },

  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    getCompanies() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company?PageNumber=1&PageSize=1000`,
          configObject.authConfig()
        )
        .then((res) => {
          this.companies = res.data.data;
        })
        .catch((error) => {});
    },
    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.branches = res.data;
        })
        .catch((error) => {});
    },
    reAssignPOS() {
      if (this.companyId == "select branch") {
        this.$toast.open({
          message: "Please select a branch to contiinue",
          type: "error",
          duration: 5000,
        });
        return;
      }

      // const data = {
      //   terminalId: this.modalDataValues.terminalId,
      //   serialNumber: this.modalDataValues.serialNo,
      //   companyId: this.$route.query.companyId
      //     ? this.$route.query.companyId
      //     : this.company.id,
      // };

      console.log(this.isLinked)
      const nonLinkedData = {
        terminalId: this.modalData.terminalId,
        companyId: this.$route.query.companyId
          ? this.$route.query.companyId
          : this.company.id,
        serialNumber: this.modalData.serialNo,
      };

      const linkedData = {
        id: this.modalData.id,
        companyId: this.$route.query.companyId
          ? this.$route.query.companyId
          : this.company.id,
        branchId: this.modalDataValues.branchId,

        transactionLimit: parseInt(this.modalData.transactionLimit),
        fee: parseFloat(this.modalData.fee),
        bank: this.modalData.bank.toUpperCase(),
        isFuelmetrics: this.modalData.isFuelmetrics,
        terminalId: this.modalData.terminalId,
        serialNo: this.modalData.serialNo,
        vendor: this.modalData.vendor,
        owner: this.modalData.owner,
        linked: true,
        terminalType: Number(this.modalData.terminalType),
        slipHeader: this.modalData.slipHeader,
        slipFooter: this.modalData.slipFooter,
      };

      $(".loader").show();
      this.isButtonDisabled = true;

      const linkedUrl = `${configObject.posBaseUrl}/Pos/Update`;
      const nonLinkedUrl = `${configObject.apiBaseUrl}/Pos/ReassignPOS/${this.modalDataValues.branchId}`;

      const url = this.isLinked ? linkedUrl : nonLinkedUrl;
      const data = this.isLinked ? linkedData : nonLinkedData;
      const config = this.isLinked? configObject.remisConfig(): configObject.authConfig()
      this.axios
        .post(url, data, config)
        .then((res) => {
          this.closeModal();
          this.$toast.open({
            message: this.$t("text.omit.successfullyReassignedPOS"),
            type: "success",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$eventHub.$emit("refreshTerminalsList");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();

          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
    closeModal() {
      this.$modal.hide("reAssignPOS");
    },
    opened() {
      this.modalDataValues = this.modalData;
      this.getBranches();
    },
  },
};
</script>
